module.exports = __webpack_public_path__ + "4a51e4054ae546b6d5dcaaa38b4a280f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/font/31E6D3_1_0.woff2
// module id = 2249
// module chunks = 2